import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import environment from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  private readonly router = inject(Router);
  private appInsights!: ApplicationInsights;

  constructor() {
    const angularPlugin = new AngularPlugin();
    if (environment.insightInstrumentationKey)
      this.appInsights = new ApplicationInsights({
        config: {
          enableAutoRouteTracking: true,
          extensionConfig: {
            [angularPlugin.identifier]: { router: this.router },
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          extensions: [angularPlugin as any],
          instrumentationKey: environment.insightInstrumentationKey,
        },
      });
  }

  init() {
    if (environment.insightInstrumentationKey)
      this.appInsights.loadAppInsights();
  }

  trackEvent(name: string, properties?: { [key: string]: unknown }) {
    if (environment.insightInstrumentationKey)
      this.appInsights.trackEvent({ name, properties });
  }

  trackTrace(message: string, properties?: { [key: string]: unknown }) {
    if (environment.insightInstrumentationKey)
      this.appInsights.trackTrace({ message, properties });
  }

  trackError(error: Error, properties?: { [key: string]: unknown }) {
    if (environment.insightInstrumentationKey)
      this.appInsights.trackException({ exception: error, properties });
  }
}
